export const LABELS = {
  canNotComment: (subjectType?: string) =>
    subjectType
      ? `You do not have permissions to comment on this ${subjectType}.`
      : 'You do not have permissions to comment.',
  confirmations: {
    deleteCommentTitle: 'Delete comment',
    deleteCommentContent: "Are you sure you'd like to delete this comment?",
    deleteCommentConfirmButtonContent: 'Delete',
  },
  hiddenComment: 'Hidden comment',
  hiddenCommentWithReason: 'Hidden as',
  issueLockedToCollaborators: 'This conversation has been locked and limited to collaborators.',
  repoArchived: 'This repository has been archived.',
  sentViaEmail: 'via email',
  commentAuthor: 'Author',
  spammyBadge: 'Spammy',
  spammyBadgeTooltip: 'This user is marked as spammy. Their comments will only show in staff mode.',
  sponsorBadge: 'Sponsor',
  newComment: 'new Comment',
  newCommentPlaceholder: 'Use Markdown to format your comment',
  commentSubjectAuthor: (viewerDidAuthor: boolean, subjectType?: string) =>
    `${viewerDidAuthor ? 'You are the' : 'This user is the'} author${subjectType ? ` of this ${subjectType}` : ''}`,
  sponsor: (owner: string, since: string) => `${owner}'s sponsor since ${since}`,
  noDescriptionProvided: 'No description provided.',
  staleCommentErrorPrefix: 'GraphQL error: STALE_DATA',
  issueConvertedToDiscussion: 'Commenting has been disabled because this issue was converted to a',
  authorLabel: (isBot: boolean, isCopilot: boolean) => `${isBot ? (isCopilot ? 'AI' : 'bot') : 'mannequin'}`,
}
